/* assets/recently-viewed.js – Dawn 15.4.0
   - Dawn card 樣式 + 輪播/靜態
   - 輪播可依欄數設定排版（每頁 UL 套 Dawn grid 類名）
   - 內建輪播控制（prev/next/dots），不依賴 theme 的 slider 初始化
   - ★ 中央計數預設顯示「頁數 / 總頁數」（例：1/3），採用 Dawn 原生
     slider-counter 樣式（.slider-counter--counter.caption）
     * 若在 section 加 data-counter-mode="items"，會顯示「當前頁數 / 總商品數」
   - 前台：只在有資料時顯示；略過當前商品、略過下架商品、最新在前
   - 後台（設計模式）：顯示假資料以便排版
   - 自動套用商店 money_format；無則安全回退
*/

(() => {
  if (window.__RV_SCRIPT_ACTIVE__) return;
  window.__RV_SCRIPT_ACTIVE__ = true;

  const STORAGE_KEY = 'rv:products:v1';
  const MAX_STORE = 50;
  const SECTION_SELECTOR = '[data-rv-section]';

  const log = (...a) => { if (window.rvDebug) console.debug('[RV]', ...a); };
  const warn = (...a) => console.warn('[RV]', ...a);

  /* ---------- money format ---------- */
  function getMoneyFormat() {
    if (window.Shopify && typeof Shopify.money_format === 'string' && Shopify.money_format) return Shopify.money_format;
    if (window.Shopify && Shopify.currency && typeof Shopify.currency.money_format === 'string' && Shopify.currency.money_format) return Shopify.currency.money_format;
    if (typeof window.__SHOP_MONEY_FORMAT === 'string' && window.__SHOP_MONEY_FORMAT) return window.__SHOP_MONEY_FORMAT;
    return '{{amount}}';
  }
  function formatMoney(cents, moneyFormat) {
    const fmt = moneyFormat || getMoneyFormat();
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents, fmt); } catch(e) {}
    }
    const value = (cents || 0) / 100;
    const withDelims = (n, p, thou, dec) => {
      p = isNaN(p) ? 2 : Math.max(0, p);
      thou = thou || ',';
      dec = dec || '.';
      const parts = Number(n).toFixed(p).split('.');
      const i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? i + dec + parts[1] : i;
    };
    if (fmt.includes('{{amount_no_decimals_with_comma_separator}}')) return fmt.replace('{{amount_no_decimals_with_comma_separator}}', withDelims(value, 0, '.', ','));
    if (fmt.includes('{{amount_with_comma_separator}}'))        return fmt.replace('{{amount_with_comma_separator}}',        withDelims(value, 2, '.', ','));
    if (fmt.includes('{{amount_no_decimals}}'))                  return fmt.replace('{{amount_no_decimals}}',                  withDelims(value, 0, ',', '.'));
    return fmt.replace('{{amount}}', withDelims(value, 2, ',', '.'));
  }

  const escapeHtml = s => (s || '').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39'}[m]));
  const aspectClass = r => r === 'portrait' ? 'media--portrait' : r === 'landscape' ? 'media--landscape' : r === 'square' ? 'media--square' : 'media--adapt';
  const ratioPercent = r => r === 'square' ? 100 : r === 'portrait' ? 150 : r === 'landscape' ? 66.66 : 100;

  function resolveImageUrl(prod) {
    let img = null;
    if (prod.images && prod.images.length) img = prod.images[0];
    else if (prod.featured_image) img = prod.featured_image;
    else if (prod.media && prod.media.length) {
      const m = prod.media[0];
      img = m?.src || m?.preview_image || m?.image || m?.url || null;
    }
    if (!img && prod.variants && prod.variants.length) {
      const vimg = prod.variants[0]?.featured_image;
      if (vimg) img = vimg.src || vimg.url || vimg;
    }
    let url = null;
    if (typeof img === 'string') url = img;
    else if (img && typeof img === 'object') url = img.src || img.url || img.originalSrc || null;
    if (!url) return null;
    if (url.startsWith('//')) url = (location.protocol || 'https:') + url;
    try {
      const u = new URL(url, location.origin);
      if (/cdn\.shopify\.com$/.test(u.hostname)) {
        const parts = u.pathname.split('.');
        const ext = parts.pop();
        const base = parts.join('.');
        if (!/_\d+x\d*$/.test(base)) u.pathname = `${base}_600x.${ext}`;
        return u.toString();
      }
    } catch(_) {}
    return url;
  }

  function chunk(arr, size) {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  }
  function buildDotsHTML(slideCount, controlsId) {
    if (slideCount <= 1) return '';
    let html = '';
    for (let i = 1; i <= slideCount; i++) {
      html += `<button class="slider-counter__link slider-counter__link--dots link" aria-controls="${controlsId}" aria-label="Go to slide ${i}" ${i===1?'aria-current="true"':''}></button>`;
    }
    return html;
  }

  /* ---------- storage & env ---------- */
  function readViews() {
    try { return (JSON.parse(localStorage.getItem(STORAGE_KEY)) || []).sort((a,b)=>(b.ts||0)-(a.ts||0)); }
    catch(e){ return []; }
  }
  function recordView(handle, id, url) {
    if (!handle && !url) return;
    let list = readViews().filter(i => (url && i.url) ? i.url !== url : (handle && i.handle) ? i.handle !== handle : true);
    list.unshift({ handle: handle || null, url: url || null, id: id || null, ts: Date.now() });
    if (list.length > MAX_STORE) list = list.slice(0, MAX_STORE);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }
  function getCurrentProductHandle() {
    const el = document.querySelector('[data-product-handle]');
    if (el) return el.getAttribute('data-product-handle');
    const m = location.pathname.match(/\/products\/([^\/?#]+)/i);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function getCurrentProductUrl() {
    const el = document.querySelector('[data-url]');
    if (el) return el.getAttribute('data-url');
    const m = location.pathname.match(/\/products\/[^\/?#]+/i);
    return m ? m[0] : null;
  }
  async function fetchProductByUrl(url) {
    const res = await fetch(url.endsWith('.js') ? url : url + '.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('fetch url ' + res.status);
    return await res.json();
  }
  async function fetchProductByHandle(handle) {
    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('fetch handle ' + res.status);
    return await res.json();
  }

  /* ---------- card builders ---------- */
  function createProductCardHTML(prod, opts, sectionId) {
    const productUrl = `/products/${prod.handle}`;
    const imgUrl = resolveImageUrl(prod);
    const price = prod.price;
    const compareAt = prod.compare_at_price_max;
    const ratio = opts.media_aspect_ratio || 'adapt';
    const ratioP = ratioPercent(ratio);
    const mediaClass = aspectClass(ratio);

    const priceHtml = `
      <div class="price">
        ${
          (compareAt && compareAt > price)
            ? `<div class="price__container">
                 <div class="price__regular">
                   <span class="price-item price-item--regular">${formatMoney(price, opts.moneyFormat)}</span>
                 </div>
                 <div class="price__sale">
                   <span class="visually-hidden">Sale price</span>
                   <span class="price-item price-item--sale">${formatMoney(price, opts.moneyFormat)}</span>
                   <span class="price-item price-item--compare">${formatMoney(compareAt, opts.moneyFormat)}</span>
                 </div>
               </div>`
            : `<div class="price__container">
                 <span class="price-item price-item--regular">${formatMoney(price, opts.moneyFormat)}</span>
               </div>`
        }
      </div>
    `;
    const imageHtml = `
      <div class="ratio" style="--ratio-percent:${ratioP}%;">
        <div class="card__media">
          <a href="${productUrl}" class="full-unstyled-link">
            <div class="media media--transparent ${mediaClass}">
              ${ imgUrl
                ? `<img src="${imgUrl}" alt="${escapeHtml(prod.title)}" loading="lazy" class="motion-reduce" width="600" height="600">`
                : `<div class="placeholder-svg placeholder">No image</div>`}
            </div>
          </a>
        </div>
      </div>
    `;
    return `
      <li class="grid__item">
        <div class="card-wrapper underline-links-hover">
          <div class="card card--product">
            <div class="card__inner color-background-2 gradient">
              ${imageHtml}
              <div class="card__content">
                <div class="card-information">
                  <h3 class="card__heading h5">
                    <a href="${productUrl}" id="CardLink-${sectionId}-${prod.id}" class="full-unstyled-link">${escapeHtml(prod.title)}</a>
                  </h3>

                  ${opts.show_vendor ? `<div class="card__vendor caption-with-letter-spacing">${escapeHtml(prod.vendor || '')}</div>` : ''}

                  ${priceHtml}
                  ${opts.show_rating ? `<div class="rating" aria-label="Product rating"></div>` : ''}
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    `;
  }

  function createDummyCardHTML(idx, opts, sectionId) {
    const ratio = opts.media_aspect_ratio || 'adapt';
    a = ratio; // no-op keep
    const ratioP = ratioPercent(ratio);
    const mediaClass = aspectClass(ratio);
    const title = `Sample product ${idx}`;
    const priceCents = 1999 * idx;

    const imageHtml = `
      <div class="ratio" style="--ratio-percent:${ratioP}%;">
        <div class="card__media">
          <a href="#" class="full-unstyled-link" tabindex="-1" aria-disabled="true">
            <div class="media media--transparent ${mediaClass}">
              <img
                src="data:image/svg+xml;charset=utf-8,${encodeURIComponent(
                  `<svg xmlns='http://www.w3.org/2000/svg' width='600' height='600'>
                     <rect width='100%' height='100%' fill='#f2f2f2'/>
                     <text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='#9e9e9e' font-family='Arial' font-size='22'>${title}</text>
                   </svg>`
                )}"
                alt="${escapeHtml(title)}" loading="lazy" class="motion-reduce" width="600" height="600">
            </div>
          </a>
        </div>
      </div>
    `;
    const priceHtml = `
      <div class="price">
        <div class="price__container">
          <span class="price-item price-item--regular">${formatMoney(priceCents, opts.moneyFormat)}</span>
        </div>
      </div>
    `;
    return `
      <li class="grid__item">
        <div class="card-wrapper underline-links-hover">
          <div class="card card--product">
            <div class="card__inner color-background-2 gradient">
              ${imageHtml}
              <div class="card__content">
                <div class="card-information">
                  <h3 class="card__heading h5"><span class="full-unstyled-link">${escapeHtml(title)}</span></h3>

                   ${opts.show_vendor ? `<div class="card__vendor caption-with-letter-spacing">Vendor</div>` : ''}

                  ${priceHtml}
                  ${opts.show_rating ? `<div class="rating" aria-label="Product rating"></div>` : ''}
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    `;
  }

  /* ---------- counter（Dawn 原生樣式） ---------- */
  function ensureCounterEl(sectionEl) {
    let el = sectionEl.querySelector('[data-rv-counter]');
    if (!el) {
      const btns = sectionEl.querySelector('.slider-buttons');
      if (!btns) return null;
      el = document.createElement('div');
      el.className = 'slider-counter slider-counter--counter caption';
      el.setAttribute('data-rv-counter', '');
      el.innerHTML = `
        <span class="slider-counter--current">1</span>
        <span aria-hidden="true"> / </span>
        <span class="slider-counter--total">1</span>
      `;
      // 放在 dots 前
      const dotsWrap = btns.querySelector('.slider-counter.slider-counter--dots');
      if (dotsWrap) btns.insertBefore(el, dotsWrap);
      else btns.insertBefore(el, btns.children[1] || null);
    } else {
      // 如果以前是 fraction 樣式，轉成 Dawn 樣式
      if (!el.querySelector('.slider-counter--current')) {
        el.className = 'slider-counter slider-counter--counter caption';
        el.innerHTML = `
          <span class="slider-counter--current">1</span>
          <span aria-hidden="true"> / </span>
          <span class="slider-counter--total">1</span>
        `;
      } else {
        // 確保類名正確，這樣會吃到 Dawn 字距/字級
        el.classList.add('slider-counter', 'slider-counter--counter', 'caption');
      }
    }
    return el;
  }

  // mode: 'pages'（預設）或 'items'
  function updateRvCounter(sectionEl, currentPageIdx, slideCount, totalItems) {
    const el = ensureCounterEl(sectionEl);
    if (!el) return;
    const modeAttr = (sectionEl.getAttribute('data-counter-mode') || '').toLowerCase();
    const mode = modeAttr === 'items' ? 'items' : 'pages'; // default pages
    const cur = el.querySelector('.slider-counter--current');
    const tot = el.querySelector('.slider-counter--total');
    if (!cur || !tot) return;

    if (mode === 'pages') {
      cur.textContent = String(currentPageIdx + 1);
      tot.textContent = String(slideCount);
    } else {
      cur.textContent = String(currentPageIdx + 1);
      tot.textContent = String(totalItems);
    }
  }

  /* ---------- our slider wiring (fallback) ---------- */
  function wireOurSlider(sectionEl, sliderEl, pagesLen, totalItems) {
    const btnPrev  = sectionEl.querySelector('.slider-button--prev');
    const btnNext  = sectionEl.querySelector('.slider-button--next');
    const dotsWrap = sectionEl.querySelector('[data-rv-dots]');
    const slides   = Array.from(sliderEl.querySelectorAll('.slider__slide'));
    const pageCounterEl = sectionEl.querySelector('[data-rv-page-counter]');
    const setPageCounter = (pageIdx) => {
  if (!pageCounterEl) return;
  const totalPages = slides.length;
  pageCounterEl.textContent = `${pageIdx + 1} / ${totalPages}`;
};

    if (slides.length <= 1) {
      if (dotsWrap) dotsWrap.innerHTML = '';
      sectionEl.querySelector('.slider-buttons')?.classList.add('hidden');
      updateRvCounter(sectionEl, 0, 1, totalItems); // 單頁仍顯示 1/1（pages）
      setPageCounter(0);
      return;
    }

    if (dotsWrap) dotsWrap.innerHTML = buildDotsHTML(slides.length, sliderEl.id || '');
    const dots = Array.from(dotsWrap?.querySelectorAll('.slider-counter__link') || []);

    let index = 0;
    const goTo = (i) => {
      index = (i + slides.length) % slides.length;
      const target = slides[index];
      sliderEl.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      dots.forEach((d, di) => d.toggleAttribute('aria-current', di === index));
      updateRvCounter(sectionEl, index, slides.length, totalItems);
      setPageCounter(index); 
    };

    btnPrev?.addEventListener('click', () => goTo(index - 1));
    btnNext?.addEventListener('click', () => goTo(index + 1));
    dots.forEach((d, di) => d.addEventListener('click', () => goTo(di)));

// 僅在「真的能水平滾動」時才攔截；否則放行交給頁面垂直捲動
sliderEl.addEventListener('wheel', (e) => {
  // 觸控板/滑鼠：主要為垂直滾動才處理（水平就交給瀏覽器）
  if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;

  const max = sliderEl.scrollWidth - sliderEl.clientWidth;
  if (max <= 0) return; // 沒有可滾內容，放行

  const before = sliderEl.scrollLeft;
  // 將垂直量轉為水平量（正值向右）
  sliderEl.scrollLeft = Math.min(max, Math.max(0, before + e.deltaY));

  const changed = sliderEl.scrollLeft !== before;
  if (changed) {
    // 真的有水平移動到，就阻止預設的垂直捲動
    e.preventDefault();
  }
}, { passive: false });


    sliderEl.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') goTo(index + 1);
      if (e.key === 'ArrowLeft') goTo(index - 1);
    });

    sliderEl.style.scrollBehavior = 'smooth';
    sliderEl.style.scrollSnapType = 'x mandatory';

    sectionEl.querySelector('.slider-buttons')?.classList.remove('hidden');
    goTo(0);
    setPageCounter(0);
  }

  /* ---------- render ---------- */
  async function renderSection(sectionEl) {
    const sectionId    = sectionEl.getAttribute('data-section-id') || 'rv';
    const count        = parseInt(sectionEl.getAttribute('data-count') || '8', 10);
    const rawCount = parseInt(sectionEl.getAttribute('data-count') || '8', 10);

// 手機上最多顯示 6 個
let effectiveCount = rawCount;
if (window.innerWidth < 750 && effectiveCount > 6) {
  effectiveCount = 6;
}

    const showVendor   = sectionEl.getAttribute('data-show-vendor') === 'true';
    const showRating   = sectionEl.getAttribute('data-show-rating') === 'true';
    const aspect       = sectionEl.getAttribute('data-aspect') || 'adapt';
    const enableSlider = sectionEl.getAttribute('data-enable-slider') === 'true';
    const perSlide     = parseInt(sectionEl.getAttribute('data-per-slide') || '3', 10);
    const isDesignMode = (typeof Shopify !== 'undefined' && Shopify.designMode === true) || sectionEl.getAttribute('data-design-mode') === 'true';

    // 靜態 grid 欄數
    const gridColsDesktop = parseInt(sectionEl.getAttribute('data-cols-desktop') || '4', 10);
    const gridColsMobile  = sectionEl.getAttribute('data-cols-mobile') || '2';
    const gridMobileClass = gridColsMobile === '1' ? 'grid--1-col-mobile' : 'grid--2-col-mobile';
    const ulClassGrid     = `grid product-grid grid--2-col-tablet grid--${gridColsDesktop}-col-desktop ${gridMobileClass} grid--peek rv-slide-list`;

    // 輪播專用欄數（未提供回退到上面數值）
    const sliderColsDesktop = parseInt(sectionEl.getAttribute('data-slider-cols-desktop') || sectionEl.getAttribute('data-cols-desktop') || '4', 10);
    const sliderColsMobile  = sectionEl.getAttribute('data-slider-cols-mobile') || sectionEl.getAttribute('data-cols-mobile') || '2';
    const sliderMobileClass = sliderColsMobile === '1' ? 'grid--1-col-mobile' : 'grid--2-col-mobile';
    const ulClassSlider     = `grid product-grid grid--2-col-tablet grid--${sliderColsDesktop}-col-desktop ${sliderMobileClass} grid--peek rv-slide-list`;

    const opts = { show_vendor: showVendor, show_rating: showRating, media_aspect_ratio: aspect, moneyFormat: getMoneyFormat() };

    // 設計模式：假資料
    if (isDesignMode) {
      const cards = [];
      for (let i = 1; i <= Math.min(effectiveCount, 12); i++) cards.push(createDummyCardHTML(i, opts, sectionId));

      if (enableSlider) {
        const slider = sectionEl.querySelector('[data-rv-slider]');
        if (!slider) { sectionEl.hidden = false; return; }
        slider.id = slider.id || `RV-Slider-${sectionId}`;

        const pages = chunk(cards, Math.max(1, perSlide));
        slider.innerHTML = pages.map((htmlList, idx) => `
          <div id="Slide-${sectionId}-${idx+1}" class="grid__item slider__slide" role="group" aria-roledescription="slide" aria-label="${idx+1} of ${pages.length}">
            <ul class="${ulClassSlider}">${htmlList.join('')}</ul>
          </div>
        `).join('');

        wireOurSlider(sectionEl, slider, pages.length, cards.length);
      } else {
        const grid = sectionEl.querySelector('[data-rv-grid]');
        if (grid) grid.innerHTML = cards.join('');
      }
      sectionEl.hidden = false;
      return;
    }

    // 前台資料
    let list = readViews();
    if (!list.length) { sectionEl.remove(); return; }

    // 略過當前商品 & 去重
    const currentHandle = getCurrentProductHandle();
    const uniq = [];
    const seen = new Set();
    for (const it of list) {
      if (it.handle && currentHandle && it.handle === currentHandle) continue;
      const key = (it.url || '') + '|' + (it.handle || '');
      if (!seen.has(key)) { seen.add(key); uniq.push(it); }
    }
    if (!uniq.length) { sectionEl.remove(); return; }

    // 拉商品 JSON
    const cards = [];
    for (const item of uniq) {
      if (cards.length >= effectiveCount) break;
      try {
        let p = null;
        if (item.url)   { try { p = await fetchProductByUrl(item.url);   } catch (e) {} }
        if (!p && item.handle) { try { p = await fetchProductByHandle(item.handle); } catch (e) {} }
        if (p && p.available !== false) cards.push(createProductCardHTML(p, opts, sectionId));
      } catch (e) {}
    }
    if (!cards.length) { sectionEl.remove(); return; }

    if (enableSlider) {
      const slider = sectionEl.querySelector('[data-rv-slider]');
      if (!slider) { sectionEl.remove(); return; }
      slider.id = slider.id || `RV-Slider-${sectionId}`;

      const pages = chunk(cards, Math.max(1, perSlide));
      slider.innerHTML = pages.map((htmlList, idx) => `
        <div id="Slide-${sectionId}-${idx+1}" class="grid__item slider__slide" role="group" aria-roledescription="slide" aria-label="${idx+1} of ${pages.length}">
          <ul class="${ulClassSlider}">${htmlList.join('')}</ul>
        </div>
      `).join('');

      wireOurSlider(sectionEl, slider, pages.length, cards.length);
    } else {
      const grid = sectionEl.querySelector('[data-rv-grid]');
      if (!grid) { sectionEl.remove(); return; }
      grid.innerHTML = cards.join('');
      if (!grid.className.includes('product-grid')) grid.className = ulClassGrid;
    }

    sectionEl.hidden = false;

    // 件數文字（若有）
    const countEl = sectionEl.querySelector('[data-rv-count]');
    if (countEl) {
      const tpl = sectionEl.getAttribute('data-count-template') || '共 {count} 件';
      const txt = tpl.replace(/\{\{count\}\}/g, String(cards.length)).replace(/\{count\}/g, String(cards.length));
      countEl.textContent = txt;
      countEl.hidden = false;
    }
  }

  /* ---------- init ---------- */
  function initRecorder() {
    try {
      const handle = getCurrentProductHandle();
      const url = getCurrentProductUrl();
      const idEl = document.querySelector('[data-product-id]');
      const pid = idEl ? (idEl.getAttribute('data-product-id') || idEl.dataset.productId) : null;
      if (handle || url) recordView(handle, pid, url);
    } catch (e) {}
  }
  function initRenderer() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(renderSection);
  }

  document.addEventListener('DOMContentLoaded', () => { initRecorder(); initRenderer(); });
  document.addEventListener('shopify:section:load', initRenderer);
  document.addEventListener('shopify:section:unload', initRenderer);

  // 除錯用
  window.__rvRenderNow = initRenderer;
  window.rvDebug = window.rvDebug || false;
})();
